import type { Observable } from 'rxjs';

import { createProviderToken } from '@core/common-legacy';

export interface ReportDashboardTemplatesCapabilities {
  canCreateCustomDashboards$: Observable<boolean>;
  openFeatureGuardDialog: () => void;
}

export const {
  inject: injectReportDashboardTemplatesCapabilities,
  provide: provideReportDashboardTemplatesCapabilities,
} = createProviderToken<ReportDashboardTemplatesCapabilities>(
  'ReportDashboardTemplatesCapabilities',
)();
